import sharedEs from './services/shared/es.json';
import sharedEn from './services/shared/en.json';
import sharedNo from './services/shared/no.json';
import sharedJp from './services/shared/jp.json';
import sharedZh from './services/shared/zh.json';
import sharedFr from './services/shared/fr.json';
import sharedAr from './services/shared/ar.json';
import sharedRu from './services/shared/ru.json';
import sharedPt from './services/shared/pt.json';
import nanooxEs from './services/nanoox/es.json';
import nanooxEn from './services/nanoox/en.json';
import nanooxNo from './services/nanoox/no.json';
import nanooxJp from './services/nanoox/jp.json';
import nanooxZh from './services/nanoox/zh.json';
import nanooxFr from './services/nanoox/fr.json';
import nanooxAr from './services/nanoox/ar.json';
import nanooxRu from './services/nanoox/ru.json';
import nanooxPt from './services/nanoox/pt.json';
import nanooxBoltEs from './services/nanooxbolt/es.json';
import nanooxBoltEn from './services/nanooxbolt/en.json';
import nanooxBoltNo from './services/nanooxbolt/no.json';
import nanooxBoltJp from './services/nanooxbolt/jp.json';
import nanooxBoltZh from './services/nanooxbolt/zh.json';
import nanooxBoltFr from './services/nanooxbolt/fr.json';
import nanooxBoltAr from './services/nanooxbolt/ar.json';
import nanooxBoltRu from './services/nanooxbolt/ru.json';
import nanooxBoltPt from './services/nanooxbolt/pt.json';
import scappEs from './services/scapp/es.json';
import scappEn from './services/scapp/en.json';
import scappNo from './services/scapp/no.json';
import scappJp from './services/scapp/jp.json';
import scappZh from './services/scapp/zh.json';
import scappFr from './services/scapp/fr.json';
import scappAr from './services/scapp/ar.json';
import scappRu from './services/scapp/ru.json';
import scappPt from './services/scapp/pt.json';
import enviroEs from './services/enviro/es.json';
import enviroEn from './services/enviro/en.json';
import enviroNo from './services/enviro/no.json';
import enviroJp from './services/enviro/jp.json';
import enviroZh from './services/enviro/zh.json';
import enviroFr from './services/enviro/fr.json';
import enviroAr from './services/enviro/ar.json';
import enviroRu from './services/enviro/ru.json';
import enviroPt from './services/enviro/pt.json';
import pssEs from './services/pss/es.json';
import pssEn from './services/pss/en.json';
import pssNo from './services/pss/no.json';
import pssJp from './services/pss/jp.json';
import pssZh from './services/pss/zh.json';
import pssFr from './services/pss/fr.json';
import pssAr from './services/pss/ar.json';
import pssRu from './services/pss/ru.json';
import pssPt from './services/pss/pt.json';

export const DEFAULT_LANGUAGE = 'es';

export const SERVICE_ALIASES = {
  default: 'shared',
  shared: 'shared',
  nanoox: 'nanoox',
  nanooxbolt: 'nanooxBolt',
  nanooxBolt: 'nanooxBolt',
  flux: 'nanooxBolt',
  scaap: 'scapp',
  scapp: 'scapp',
  enviro: 'enviro',
  pss: 'pss',
};

export const SERVICE_TRANSLATIONS = {
  shared: {
    es: sharedEs,
    en: sharedEn,
    no: sharedNo,
    jp: sharedJp,
    zh: sharedZh,
    fr: sharedFr,
    ar: sharedAr,
    ru: sharedRu,
    pt: sharedPt,
  },
  nanoox: {
    es: nanooxEs,
    en: nanooxEn,
    no: nanooxNo,
    jp: nanooxJp,
    zh: nanooxZh,
    fr: nanooxFr,
    ar: nanooxAr,
    ru: nanooxRu,
    pt: nanooxPt,
  },
  nanooxBolt: {
    es: nanooxBoltEs,
    en: nanooxBoltEn,
    no: nanooxBoltNo,
    jp: nanooxBoltJp,
    zh: nanooxBoltZh,
    fr: nanooxBoltFr,
    ar: nanooxBoltAr,
    ru: nanooxBoltRu,
    pt: nanooxBoltPt,
  },
  scapp: {
    es: scappEs,
    en: scappEn,
    no: scappNo,
    jp: scappJp,
    zh: scappZh,
    fr: scappFr,
    ar: scappAr,
    ru: scappRu,
    pt: scappPt,
  },
  enviro: {
    es: enviroEs,
    en: enviroEn,
    no: enviroNo,
    jp: enviroJp,
    zh: enviroZh,
    fr: enviroFr,
    ar: enviroAr,
    ru: enviroRu,
    pt: enviroPt,
  },
  pss: {
    es: pssEs,
    en: pssEn,
    no: pssNo,
    jp: pssJp,
    zh: pssZh,
    fr: pssFr,
    ar: pssAr,
    ru: pssRu,
    pt: pssPt,
  },
};

export const SUPPORTED_LANGUAGES = Object.keys(SERVICE_TRANSLATIONS.shared);
